// extracted by mini-css-extract-plugin
module.exports = {"file":"ViewConfirmDocument_file__2pGAV","size":"ViewConfirmDocument_size__3J5FH"};